<div class="container" *ngIf="searchMode">
  <form [formGroup]="firstFormGroup">
    <div class="amazoncontainer">
      <div class="amazoncontainer left">
        <ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false">
        </ngx-spinner>
        <div class="action" >
          <span class="link" (click)="novoAnuncio()">Criar novo produto</span>
          <div fxFlex></div>
          <div *ngIf="showCatalogoProducts">
              <button  mat-mini-fab  color="success" aria-label="Voltar" (click)="showCatalogoProducts=!showCatalogoProducts" matTooltip="Voltar para Pesquisa">
                  <mat-icon>reply</mat-icon>
              </button>
          </div>
        </div>
        <div class="data-find">
          <div class="main">
            <div class="field">
              <mat-form-field *ngIf="us.user.companylist.length > 1 ">
                <mat-label>Escolher uma Empresa</mat-label>
                <mat-select  [(ngModel)]="codecompany" [ngModelOptions]="{standalone: true}" >
                    <mat-option *ngFor="let data of us.user.companylist" [value]="data.codecompany">
                        {{data.codecompany}} - {{data.companyname}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            </div>
            <div class="field">
              <mat-form-field appearance="outline" [formGroup]="firstFormGroup" class="no-padding-form-field">
                <mat-label>Informar Dados de Busca</mat-label>
                <input  matInput formControlName="productSearch" placeholder="Nome do Produto / EAN / ASIN"   #inp type = "text" (keydown)="inputChanged()"  (keyup.enter)="pesquisar(false,$event)"  > 
                <button  matSuffix mat-icon-button aria-label="Clear" (click)="inp.value=''">
                    <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
          <div class="information" [hidden]="!showFilter"> 
            <div class="inf"><span>Exibindo {{amazonItems.length}} de {{numberOfResults}} resultados</span></div>
            <span><button mat-raised-button color="primary" [disabled]="nextToken==''" (click)="pesquisar(true)">Próximo</button></span>
          </div>
          <div class="buttonicon">
            <span><button mat-raised-button color="primary" (click)="pesquisar(false,null)">Pesquisar</button></span>
          </div>
        </div>
        <div class="card-container">
          <div fxLayout="row wrap" fxLayoutGap="16px grid" class="card-item">
            <div fxFlex="33%" fxFlex.xs="100%" fxFlex.sm="50%" *ngFor="let amazon of amazonItems" class="amazon-item">
              <ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" [name]="amazon['asin']">
              </ngx-spinner>
              <new-product-amazon [amazondata] = "amazon" (select)="selectProduct($event)"></new-product-amazon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div *ngIf="!searchMode" class="container-dados-edit">            
  <editform 
    [parentRow]="parentRow"
    [entityName]="entityName"
    [row]="row"
    [filter]="filter"
    [userConfig]="userConfig"
    [tableInformation]="tableInformation"
    [formViewColumns]="formViewColumns"
    [formGroup]="formGroup"
    [evento]="evento"
    [forceParentRow]="forceParentRow"
    [$$REFERENCES]="$$REFERENCES"
    [actionList]="actionList"
    (saving)="salvandoPrincipal($event)"
    [canConfig]="canConfig"
    [customComponents]="customComponents"
    [dataMultiTableConfig]="dataMultiTableConfig"
    >
  </editform>
</div>